<template>
  <NotificationTemplate :notification="notification">
    <template #pic>
      <slot name="pic" />
    </template>

    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
        className="idea-activity__title"
      >
        {{ title }}
      </BaseSubHeading>
    </template>

    <template #content>
      <div class="idea-activity__content">
        <BaseSubHeading
          v-if="resourceKey"
          size="medium"
          color="accent-03"
          darkColor="accent-200"
          weight="500"
          className="idea-activity__resource-key"
        >
          <a
            v-if="resourceHref"
            :href="resourceHref"
            class="link is-medium-500"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ resourceKey }}
          </a>
          <template v-else>{{ resourceKey }}</template>
        </BaseSubHeading>
        <BaseSubHeading
          size="medium"
          color="monochrome-06"
          darkColor="monochrome-03"
          weight="400"
          className="idea-activity__description"
        >
          {{ notification.ideaTitle }}
        </BaseSubHeading>
      </div>
    </template>
  </NotificationTemplate>
</template>

<script setup lang="ts">
import { computed } from "vue"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationIdeaActivity } from "@/models/Notification"

/** Keeps the shared layout of all designed Idea lifecycle notification cards consistent. */
const props = defineProps<{
  notification: NotificationIdeaActivity
  title: string
  resourceKey?: string
}>()

const resourceHref = computed(() => props.notification.resourceUrl || props.notification.ideaUrl)
</script>

<style lang="scss" scoped>
@import "@/assets/scss/utils/mixins/flex";
@import "@/assets/scss/utils/mixins/ellipsis";

.idea-activity__content {
  @include flex($align: flex-start);

  min-width: 0;
  gap: var(--step4);
}

.idea-activity__resource-key {
  flex-shrink: 0;
}

.idea-activity__description {
  @include ellipsis;

  min-width: 0;
  flex: 1;
}
</style>
